import Component from './Footer.vue';

export default Component;
